import profileFields from '../profile/fields';
import definedSchemas from '../fields/definedSchemas';
import Joi from 'joi';

const fields = {
    ...profileFields,
    applicant_previous_mmc: {
        ...definedSchemas.boolRequired,
        label: 'Have you ever had an MMC before?',
        section: 'MMC Info',
    },
    applicant_MMC: {
        ...definedSchemas.textOptional,
        section: 'MMC Info',
        hidden: true,
        validation: Joi.when('applicant_previous_mmc', {
            is: true,
            then: Joi.string().required().messages({
                'string.empty': 'Please use the form below to enter your MMC',
            }),
            otherwise: Joi.string().allow('', null),
        }),
    },
};

export default fields;
